import AddInventory from './AddInventory';

export default AddInventory;


// WEBPACK FOOTER //
// ./src/components/AddInventory/index.jsx